import { render, staticRenderFns } from "./Historico.vue?vue&type=template&id=fdfcb3f8&scoped=true"
import script from "./Historico.vue?vue&type=script&lang=js"
export * from "./Historico.vue?vue&type=script&lang=js"
import style0 from "./Historico.vue?vue&type=style&index=0&id=fdfcb3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfcb3f8",
  null
  
)

export default component.exports